const url = '/flights';
const Provider = 'Flights';
const dbModel = 'Flights';

export { url, Provider, dbModel };
